<a class="card--link" [routerLink]="routerTarget()" [attr.aria-disabled]="ariaDisabled()" [attr.tabindex]="tabIndex()">
  <mat-card class="card--interactive card--interactive-brand action-card">
    <mat-card-header>
      <div class="action-card__heading">
        <div class="action-card__icon" [class]="toneClass()" aria-hidden="true">
          <mat-icon>{{ icon() }}</mat-icon>
        </div>

        <h2 class="action-card__title heading-3 heading-flush">{{ heading() }}</h2>
      </div>
    </mat-card-header>

    <mat-card-content class="action-card__body">
      <p class="action-card__description mat-font-body-md mat-text-on-surface-variant">{{ description() }}</p>
    </mat-card-content>

    <mat-card-actions>
      <div class="action-card__footer">
        <span>{{ actionText() }}</span>
        <span class="action-card__arrow" aria-hidden="true">
          <mat-icon inline>arrow_forward</mat-icon>
        </span>
      </div>
    </mat-card-actions>
  </mat-card>
</a>
